import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useGridApiRef } from "@mui/x-data-grid";
import React, { useCallback, useEffect, useRef, useState } from "react";

import GenericTable from "../../../components/generic-table";
import ToastComponent from "../../../components/Toast";
import { useForms } from "../../../hooks/form";
import { language } from "../../../language";

const FETCH_DATA = {
  page: 0,
  pageSize: 10,
  sortBy: "id",
  sortOrder: "asc",
  draft: false,
  searchTerm: "",
  enabled: true,
};

function FormSelectList({ dataErr, handleSave, handleSelect, selectedForms }) {
  const apiRef = useGridApiRef();
  const [selecteds, setSelecteds] = useState([]);
  const [formsListData, setFormsListData] = useState([]);
  const [pagination, setPagination] = useState(FETCH_DATA);

  const { data: forms, isLoading } = useForms({ params: pagination });

  useEffect(() => {
    if (forms && forms.content && forms.content[0] !== formsListData[0]) {
      const t = Object.assign([], forms.content);
      const selectedsTemp = Object.assign([], selecteds);
      for (let i = 0; i < t.length; i++) {
        selectedForms.forEach(function (key) {
          if (t[i].id + "_v" + t[i].version === key) {
            selectedsTemp.push(t[i]);
            t[i].tableData = { id: 0, checked: true };
          }
        });
        selecteds.forEach(function (item) {
          if (t[i].id === item.id && t[i].version === item.version) {
            t[i].tableData = { id: 0, checked: true };
          }
        });
      }
      setFormsListData(t);
      setSelecteds(selectedsTemp);
    }
  }, [forms]);

  const dataTable = {
    headers: [
      {
        headerName: language.id,
        field: "id",
        flex: 1,
      },
      { headerName: language.name, field: "name", flex: 1 },
      { headerName: language.category, field: "category", flex: 1 },
    ],

    data: formsListData && formsListData.length > 0 ? formsListData : [],
  };

  return (
    <Grid container spacing={2} direction="column">
      <Grid item xs={12}>
        <Button
          color="primary"
          variant="contained"
          onClick={handleSave}
          style={{ marginBottom: "14px" }}
        >
          {language.finalizeSelection}
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ width: "100%" }}>
          <GenericTable
            apiRef={apiRef}
            tableData={dataTable}
            paginationMode="server"
            pagination={{
              callData: setPagination,
              totalElements: forms?.totalElements,
              model: {
                ...pagination,
                count: forms?.size,
                sortHeader: FETCH_DATA.sortBy,
                pageSize: pagination.pageSize,
                page: pagination.page,
              },
            }}
            onRowSelectionModelChange={useCallback(() => {
              handleSelect(apiRef.current.getSelectedRows());
            }, [apiRef])}
            checkboxSelection
            disableRowSelectionOnClick
            loading={isLoading}
          />
        </Box>
      </Grid>

      {dataErr && (
        <ToastComponent
          onClose={() => false}
          open={dataErr}
          content={dataErr && dataErr.message}
        />
      )}
    </Grid>
  );
}

export default FormSelectList;
